import { useContext } from "react";
import { AR, FileTypes } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFiles from "./RetailOrderFiles";

export default function InstallationPhotoFiles() {

	const { order } = useContext(RetailOrderContext);

	return (
		<RetailOrderFiles
			fileTypes={[FileTypes.DisplayPhoto]}
			defaultFileType={FileTypes.DisplayPhoto}
			buttonCaption={order.details.activeARs.includes(AR.CfiToUploadInstallationPhotos) ?
				'Upload Installation Photos' : undefined}
			closeOnUpload={false}
		/>
	)
}
